module.exports = __webpack_public_path__ + "static/media/pin-primary.982ba8ce.png";